import { render, staticRenderFns } from "./ChangePhoneNumberPage.vue?vue&type=template&id=9db1a19c&scoped=true"
import script from "./ChangePhoneNumberPage.vue?vue&type=script&lang=js"
export * from "./ChangePhoneNumberPage.vue?vue&type=script&lang=js"
import style0 from "./ChangePhoneNumberPage.vue?vue&type=style&index=0&id=9db1a19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db1a19c",
  null
  
)

export default component.exports